/*
 * Copyright 2021 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  identityApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { tomtomLabApiRef, TomtomLabClient } from './api';
import { rootRouteRef } from './routes';

/** @public */
export const tomtomLabPlugin = createPlugin({
  id: 'tomtom-lab',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: tomtomLabApiRef,
      deps: {
        identityApi: identityApiRef,
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ identityApi, discoveryApi, fetchApi }) =>
        new TomtomLabClient({ identityApi, discoveryApi, fetchApi }),
    }),
  ],
});

/** @public */
export const TomtomLabPage = tomtomLabPlugin.provide(
  createRoutableExtension({
    name: 'TomtomLabPage',
    component: () => import('./components/HomePage').then(m => m.HomePage),
    mountPoint: rootRouteRef,
  }),
);
